import ApiManager from '../Api.manager'
import { FilterTypes } from '../../enum/Filter.enum'
import HttpConstants from '../../constants/HttpConstants'
import { ProjectAPIOverviewData } from '../../store/CCApiOverviewStore'
import UrlConstants from '../../constants/UrlConstants'
import { getFiltersForApi } from '../../utils/FilterUtils'

export const getAPIMonitoringOrganizationOverviewAPI = (
  params: any
): Promise<{ data: ProjectAPIOverviewData[] }> => {
  const usecase = UrlConstants.GET_ORGANIZATION_API_OVERVIEW.USECASE
  const filters = getFiltersForApi(FilterTypes.API_MONITORING, params)

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}
